"use client"

import { forwardRef, useImperativeHandle, type ForwardedRef } from "react"
import { useScrambleAnimation } from "./use-scramble-animation"
import { cn } from "@/lib/utils"

export interface TextScrambleAnimationHandle {
    play: () => void
}

export const TextScrambleAnimation = forwardRef<
    TextScrambleAnimationHandle,
    {
        text: string
        lowercase?: boolean
        uppercase?: boolean
        speed?: number
        className?: string
    }
>(
    (
        { text, lowercase = false, uppercase = false, speed = 0.6, className },
        ref: ForwardedRef<TextScrambleAnimationHandle>,
    ) => {
        const { textRef, play } = useScrambleAnimation({
            lowercase,
            uppercase,
            speed,
        })

        useImperativeHandle(ref, () => ({
            play,
        }))

        return (
            <span
                ref={textRef}
                className={cn(uppercase && "uppercase", className)}
                data-text={text}
            >
                {text}
            </span>
        )
    },
)

TextScrambleAnimation.displayName = "TextScrambleAnimation"
